import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Validator } from 'redux-form'
import { Box, Skeleton } from '@mui/material'
import Dropdown from '@cbgms/components/form/Material/Dropdown'
import { useQuery } from '@cbgms/base/http/use-query'
import { useNotifier } from '@cbgms/base/notifier'
import { regionsForCountry } from 'app-support/regions/state/actions'
import { IListRegionTagsResponse } from '@cbgms/api'

const mapRegionsToDropdownOptions = (data: IListRegionTagsResponse) => {
  return data.Data.filter(r => !!r.Region).map(r => ({
    text: r.Region.Name,
    value: r.Region.UUID,
    key: r.Region.UUID
  }))
}

interface RegionsForCountryDropdownProps {
  countryCode: string
  name: string
  required?: boolean
  validate?: Validator | Validator[]
  className?: string
  fullWidth?: boolean
}

const RegionsForCountryDropdown: React.FC<RegionsForCountryDropdownProps> = props => {
  const dispatch = useDispatch()
  const notifier = useNotifier()
  const { t } = useTranslation()
  const { countryCode, ...rest } = props

  const options = useQuery(['RegionsForCountryDropdown', 'regionsForCountry', countryCode], async () => {
    if (!props.countryCode) {
      // country code has to be provided
      return []
    }
    const data = await dispatch(regionsForCountry(countryCode))
    return mapRegionsToDropdownOptions(data)
  })

  useEffect(() => {
    if (options.isError) {
      notifier.error(t('BankHoliday.FailedToLoadRegions'))
    }
  }, [options.isError])

  if (options.isLoading || !options.data) {
    return (
      <Box p={2}>
        <Skeleton height={39} variant='rectangular' />
      </Box>
    )
  }

  return <Dropdown label={t('setting_my_shop.region')} placeholder={t('setting_my_shop.region')} options={options.data ?? []} {...rest} />
}

export default RegionsForCountryDropdown
